module.exports = __webpack_public_path__ + "static/media/loan repayment_1.3d598475.png";